'use client';

import { useFlags } from 'launchdarkly-react-client-sdk';

import { useIsClient } from '../hooks/useIsClient';
import { useDevLdFlagOverridesStore } from './dev-overrides-store';

const isDev = process.env.NODE_ENV === 'development';

export function useFeatureFlag<TFlag extends string = string>(flag: TFlag): boolean {
  const flags = useFlags();
  const override = useDevLdFlagOverridesStore((state) => (isDev ? state.overrides[flag] : undefined));
  const isMounted = useIsClient();

  // Keep SSR and the initial hydration render consistent.
  if (!isMounted) return false;

  if (isDev && override !== undefined) return override;

  return flags[flag];
}
